import { useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { searchExistingAppointments } from '../api'
import { useAppSelector } from '@user/store/hooks'
import { selectEntityAppointmentsSearchLoading } from '../searchSlice'

export function useGetAppointmentsSearchDataOnMount(
  entityIds: number[],
  entityType: number,
  schedulingEnabled: boolean,
) {
  const dispatch = useAppDispatch()

  const loading = useAppSelector(selectEntityAppointmentsSearchLoading)

  useEffect(() => {
    if (entityIds.length > 0 && schedulingEnabled) {
      dispatch(
        searchExistingAppointments({
          entityIds,
          entityType,
        }),
      )
    }
  }, [dispatch, entityIds, entityType, schedulingEnabled])

  return loading
}
